export const state = {
  keyword: ""
};

export const mutations = {
  updateKeyword(state, keyword) {
    state.keyword = keyword;
  },
  clearSearch(state) {
    state.keyword = "";
  }
};

export const getters = {
  keyword: state => {
    return state.keyword;
  }
};

export const actions = {
  startSearch({ commit }, keyword) {
    return new Promise((resolve, reject) => {
      commit("updateKeyword", keyword);
    });
  },
  resetKeyword({ commit }) {
    commit("clearSearch");
  }
};
